import type { TaskConfig, TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

const stressFreeSwitchContent = ({
  affectedPolicies,
  brandFullName
}: { affectedPolicies: string; brandFullName: string }) => ({
  title: 'Stress-free switch',
  incompleteSubtitle: 'Cancel your prior insurance policy hassle-free.',
  completedSubtitle: `You have successfully submitted cancellation for your prior insurance replaced by ${affectedPolicies}.`,
  actionLabel: 'Complete now',
  modalTitle: 'Upload cancellation confirmation',
  contentSections: [
    {
      title: 'How does this work?',
      body: [
        "We've reached out to your old insurance company to cancel your policy. You should expect to receive a cancellation notice within an average of 1-2 business days.",
        'You can also reach out to your previous carrier to confirm the request yourself and ask them to expedite your refund and confirm the refund method.'
      ],
      isList: true
    },
    {
      title: 'When do I need to submit these documents?',
      body: `We encourage you to cancel with your previous insurer sooner than later to ensure a smooth transition to ${brandFullName}.`
    }
  ]
});

const baseConfig: Omit<TaskConfig, 'staffDisplayName'> = {
  reviewTeam: reviewTeams.processing,
  daysAllowed: 15,
  enabled: true,
  account: {
    toastMessage: 'Your cancellation documents have been submitted.',
    content: stressFreeSwitchContent
  }
};

export const stressFreeSwitchHome: TaskDefinition = {
  taskName: onboardingTasks.StressFreeSwitchHome,
  config: { ...baseConfig, staffDisplayName: 'Stress Free Switch - Home' }
};

export const stressFreeSwitchAuto: TaskDefinition = {
  taskName: onboardingTasks.StressFreeSwitchAuto,
  config: { ...baseConfig, staffDisplayName: 'Stress Free Switch - Auto' }
};

export const stressFreeSwitchRenters: TaskDefinition = {
  taskName: onboardingTasks.StressFreeSwitchRenters,
  config: { ...baseConfig, staffDisplayName: 'Stress Free Switch - Renters' }
};

export const stressFreeSwitchUmbrella: TaskDefinition = {
  taskName: onboardingTasks.StressFreeSwitchUmbrella,
  config: { ...baseConfig, staffDisplayName: 'Stress Free Switch - Umbrella' }
};
